import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'backoffice-rpa',
    loadChildren: () =>
      import('./modules/admin/backoffice-rpa/app.routes').then((m) => m.routes),
  },
  { path: '', pathMatch: 'full', redirectTo: 'backoffice-rpa' },
  { path: '**', redirectTo: 'backoffice-rpa' },
];
